import {getOptions} from "../../services/optionsService";

export const setOptions = () => {
    return async (dispatch) => {
        const {data} = await getOptions()
        await dispatch({type:'INIT_OPTIONS',payload:[...data.data]})
    }
}